// extracted by mini-css-extract-plugin
module.exports = {"AiDetail":"_1frLoGmRkLE0OVWQgkm8hj"};